import React, { useEffect, useState } from 'react';

import axios from 'axios';
import ModalImage from 'react-modal-image';
import { connect, useSelector } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';

import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/core/styles';

import ProviderProfile from './ProviderProfile';

import tourComplete from '../../assets/img/completeTourIcon.svg';
import tourSchedule from '../../assets/img/scheduleTourIcon.svg';
import tourRequest from '../../assets/img/tourIcon.svg';
import { EMAIL_TEMPLATES_ID } from '../../models/constant';
import { API_URLS, APPLICATION_HEADERS, CUSTOM_CLIENT_NAME } from '../../models/headers';
import useAddShortlistedoption from '../../store/contexts/useAddShortlistedoption';
import {
  calcCapacity,
  calcMonthTerms,
  formatDate,
  formatDatefromTimeStamp,
  scrollClickHandler,
  getDistanceFromLatLong,
  isRatesToInclude,
  strToArray,
  changeRequestedDate,
} from '../../utils/utils';
import HeartIcon from '../Core/CustomIcons/HeartIcon';
import ImageSlider from '../ImageSlider/ImageSlider';
import QueryModal from '../QueryModal/QueryModal';
import SuccessModal from '../QueryModal/SuccessModal';
import '../QueryModal/QueryModal.css';
import './OptionDetail.css';

function LeftArrowIcon({ onClick }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      <path fill="#003F2D" d="M7.705 1.41L6.295 0l-6 6 6 6 1.41-1.41L3.125 6l4.58-4.59z"></path>
    </svg>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const getDistance = (option, unitVal, latLong) => {
  if (option && option.lat && option.lng) {
    const latLng = latLong;

    if (latLng && latLng.length > 0) {
      const lat1 = latLng[1];
      const lat2 = option.lat;
      const lon1 = latLng[0];
      const lon2 = option.lng;
      const distance1 = parseFloat(getDistanceFromLatLong(lat1, lon1, lat2, lon2, unitVal)).toFixed(
        2,
      );

      const unit = unitVal == 'miles' ? 'Miles ' : 'KM ';

      return distance1 + ' ' + unit + 'from current location';
    }

    return '';
  }

  return '';
};

const OptionDetail = (props) => {
  const data = useSelector((state) => state.optRed.data);
  const classes = useStyles();
  const { surveyId } = useParams();
  const isPdfContent = useSelector((state) => state.comRed.pdfDownload);

  const [floorClick, setFloorClick] = useState(true);
  const [photosClick, setPhotosClick] = useState(false);
  const [openSuccess, setOpenSuccess] = React.useState(false);
  const { option, showNav, shortlistedOptions, isShortlistedSearch } = props;

  const [showFloorPlans, setShowFloorPlans] = useState(true);
  const [showPhotos, setShowPhotos] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [requestType, setRequestType] = React.useState('');
  const [showProfileModal, setShowProfileModal] = useState(false);

  const [message, setMessage] = React.useState('');

  const [isSelected, setIsSelected] = useState(option?.shortListed);

  const location = useLocation();
  const currentPathName = location.pathname;

  const isPreviewStrPresent = currentPathName.includes('preview');

  const {
    surveyData,
    optData,
    ccemails,
    flexpertEmail,
    shortlistedProviderName,
    shortlistedProviderEmails,
    commonQuery,
    currentDeal,
    majorProviders,
  } = props;
  const { putOption, inProgress } = useAddShortlistedoption(option);
  const { pdfDownload } = props;

  const currentProvider = majorProviders?.filter((provider) => {
    return provider.providerName == option.providerName;
  });

  useEffect(() => {
    setIsSelected(option?.shortListed);
  }, [option.shortListed]);

  const addShortlistedOptions = () => {
    putOption(() => {
      props.shortListed('ADD');
    }, 'ADD');
  };

  const removeShortlistedOption = (id) => {
    putOption(() => {
      props.removeFromShortlistedOptions(id);
      props.shortListed('REMOVE');
    }, 'REMOVE');
  };

  let rateVariableTerm = '';
  let monthTerms = {
    rateOneMonth: '',
    rateSixMonths: '',
    rateTwelveMonths: '',
    ratetwentyfourmonths: '',
    rateVariable: '',
  };

  const tourDate = formatDatefromTimeStamp(option.tourScheduledDate, 'MMM DD, YYYY');
  const tourScheduleSlot = `${tourDate} - ${option.tourScheduledSlot}`;

  const formatNum = (num) => {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  };

  if (option && option.officeType === 'EXTERIOR') {
    option.officeType = '(External)';
  }
  if (option && option.officeType === 'INTERIOR') {
    option.officeType = '(Internal)';
  }

  if (option && option.availableSpaceList) {
    monthTerms = calcMonthTerms(option);
  }

  if (option && option.rateVariableTerm) {
    rateVariableTerm = option?.rateVariableTerm?.split(' ')[0]?.trim();
  }

  const displayFloor = () => {
    setShowFloorPlans(true);
    setShowPhotos(null);
    setFloorClick(true);
    setPhotosClick(false);
  };

  const displayPhotos = () => {
    setShowFloorPlans(null);
    setShowPhotos(true);
    setFloorClick(false);
    setPhotosClick(true);
  };

  const setFloorPlanImage = () => {
    if (option && option.floorPlan) {
      return option.floorPlan.replace(
        process.env.REACT_APP_PDF_IMAGE_URL.trim(),
        process.env.REACT_APP_PDF_REPLACE_IMAGE_URL.trim(),
      );
    }
    if (option && option.floorPlan && option.floorPlan.includes('us-east-1')) {
      return option.floorPlan.replace(
        process.env.REACT_APP_PDF_HERO_IMAGE_URL.trim(),
        process.env.REACT_APP_PDF_REPLACE_IMAGE_URL.trim(),
      );
    }
  };

  const deg2rad = (deg) => {
    return deg * (Math.PI / 180);
  };

  const handleOpen = (value) => {
    setOpen(true);
    setRequestType(value);
  };

  const handleSuccessClose = () => {
    setOpenSuccess(false);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const updateDEALInfo = (url, obj, headers) => {
    axios
      .put(url, obj, { headers })
      .then((res) => {
        if (res && res.status === 200) {
          console.log('successfully updated deal info');
        }
      })
      .catch((error) => {
        if (error.response) {
          console.log('error', error);
        } else {
          updateDEALInfo(url, obj, headers);
        }
      });
  };
  const getAllProviders = (options) => {
    const allProviders = [];

    const iterateOptions = optData?.options ?? optData?.optionProviderRequestList;

    for (const o of iterateOptions) {
      const obj = {};

      if (o.providerEmail) {
        obj.providerEmail = o.providerEmail;
        obj.optionId = o.id;
        obj.address = o.address;
        obj.optionname = o.optionName;
        if (o.availableSpaceList) {
          obj.unitArray = o.availableSpaceList.map((avail) => avail.unit);
        }
        allProviders.push(obj);
      }
    }

    return allProviders;
  };

  const simplifiedFunction = (value, allProvidersCheck) => {
    handleClose();
    setOpenSuccess(value);
    setTimeout(function () {
      handleSuccessClose();
    }, 8000);
    setMessage('SUCCESS');

    //displaying message after update successful

    if (requestType === 'TOUR' || requestType === 'PROPOSAL') {
      const stage = requestType === 'TOUR' ? 'Tour' : 'Negotiation';

      const reqObj = {
        dealId: currentDeal && currentDeal['DealID'],
        stage: stage,
      };
      let providerEmail, providerName;

      if (requestType === 'TOUR' && option.providerEmail) {
        let pemails;

        if (shortlistedProviderEmails && shortlistedProviderEmails != '\n') {
          pemails = shortlistedProviderEmails.trim() + ',' + option.providerEmail.trim();
        } else {
          pemails = option.providerEmail.trim();
        }
        pemails = Array.from(new Set(pemails.split(','))).toString();

        providerEmail = pemails;
        reqObj.shortlistedProviderContact = providerEmail;
      }
      if (requestType === 'TOUR' && option.providerName) {
        let pname;

        if (shortlistedProviderName && shortlistedProviderName != '\n') {
          pname = shortlistedProviderName.trim() + ',' + option.optionName.trim();
        } else {
          pname = option.optionName.trim();
        }
        providerName = pname;
        reqObj.shortlistedProvider = providerName;
      }

      if (reqObj.dealId) {
        //api calling to update
        const dealURL = API_URLS.updateDealURL;

        updateDEALInfo(dealURL, reqObj, { headers: APPLICATION_HEADERS.dealHeaders });
      }
    }

    // if (requestType === "QUERY") {
    //axios call for sending email API

    //unit value
    let unitArray = [];

    if (option.availableSpaceList) {
      unitArray = option.availableSpaceList.map((avail) => avail.unit);
    }
    let providerEmail, templateId;

    if (option.providerEmail) {
      providerEmail = option.providerEmail;
    }
    //if TOUR and Agreement send emails {To: daisy.perez@cbre.com, marie.phillips@cbre.com} and cc
    // {cc: rahul.surana@cbre.com,sam.pickus@cbre.com}

    if (requestType === 'TOUR') {
      templateId = EMAIL_TEMPLATES_ID.TOUR_REQUEST;
    }
    if (requestType === 'PROPOSAL') {
      templateId = EMAIL_TEMPLATES_ID.PROPOSAL_REQUEST;
    }
    let allProviders;

    if (requestType === 'QUERY') {
      templateId = EMAIL_TEMPLATES_ID.CLIENT_QUERY_REQUEST;
      if (allProvidersCheck) {
        allProviders = getAllProviders(optData);
      }
    }

    const reqObj = {
      toMail: providerEmail, //Provider Email get from main object
      templateId: templateId,
      templateInputs: {
        option_name: option.optionName ? option.optionName : '',
        provider_location: option.address ? option.address.address : '',
        unit_number: unitArray ? unitArray.toString() : '',
        provider_form: `${process.env.REACT_APP_FAST_LINK.trim()}/client_query_request/${
          option.id
        }/${surveyId}`,
        provider_preview_link: process.env.REACT_APP_CD_LINK.trim() + '/preview/' + option.id,
        deal_id: currentDeal && currentDeal['DealID'],
      },
    };

    if (ccemails && requestType === 'QUERY') {
      reqObj.ccMail = ccemails.toString();
    }

    if (requestType === 'TOUR' || requestType === 'PROPOSAL') {
      if (flexpertEmail.length > 0) reqObj.toMail = flexpertEmail.toString();
      //as flexpertemail and ccflexpert emails are same
      reqObj.templateInputs.client_name = currentDeal && currentDeal['Client'];
      reqObj.templateInputs.provider_name = option.providerName;
    }

    if (reqObj.toMail && !allProvidersCheck) {
      const optionURL = API_URLS.sendMailURL;

      axios
        .post(optionURL, reqObj, { headers: APPLICATION_HEADERS.dealHeaders })
        .then((res) => {
          if (res && res.status === 202) {
            console.log('successfully sent mail');
          }
        })
        .catch((error) => {
          console.log('error', error);
        });
      //ask question to all providers sending email
    } else if (allProvidersCheck && allProviders.length >= 1) {
      for (const option1 of allProviders) {
        const optionURL = API_URLS.sendMailURL;

        //request object change based on option
        reqObj.toMail = option1.providerEmail.toString(); //provider email
        reqObj.templateInputs.option_name = option1.optionname;
        reqObj.templateInputs.provider_location = option1.address ? option1.address.address : '';
        reqObj.templateInputs.unit_number = option1.unitArray ? option1.unitArray.toString() : '';
        reqObj.templateInputs.provider_form = `${process.env.REACT_APP_FAST_LINK.trim()}/client_query_request/${
          option1.optionId
        }/${surveyId}`;
        reqObj.templateInputs.provider_preview_link =
          process.env.REACT_APP_CD_LINK.trim() + '/preview/' + option1.optionId;

        if (reqObj.toMail) {
          axios
            .post(optionURL, reqObj, { headers: APPLICATION_HEADERS.dealHeaders })
            .then((res) => {
              if (res && res.status === 202) {
                let finalCommonquery;

                if (props.commonQuery) {
                  finalCommonquery = props.commonQuery + ' \r\n' + option.commonqueryData;
                  props.setCommonQuery(finalCommonquery);
                } else {
                  props.setCommonQuery(option.commonqueryData);
                }
              }
            })
            .catch((error) => {
              console.log('error', error);
            });
        }
      }
    }
  };

  const floorImage = () => {
    return (
      <ModalImage
        small={setFloorPlanImage()}
        large={setFloorPlanImage()}
        alt=""
        hideDownload="true"
        className="floorImage"
        style={{ maxHeight: 'none' }}
      />
    );
  };

  const createMarkup = (data) => {
    return { __html: data };
  };

  const toggleIcon = () => {
    if (isSelected) {
      props.setIsShortlisted(option.id, false);
      setIsSelected(false);
      removeShortlistedOption(option.id);
    }

    if (!isSelected) {
      props.setIsShortlisted(option.id, true);
      setIsSelected(true);
      addShortlistedOptions();
    }
  };

  return (
    <div className="optionDetails" id={props.idProp}>
      <div style={{ width: '100%' }}>
        {inProgress && (
          <span className="spinner">
            <CircularProgress color="inherit" />
          </span>
        )}
        <div className="leftHalf">
          <div className="heading" style={{ width: '100%' }}>
            <div style={{ fontSize: '28px', fontWeight: 'bold' }}>
              {showNav === true && (
                <span
                  style={{
                    position: 'absolute',
                    left: '7px',
                  }}
                >
                  {!pdfDownload && (
                    <div className="left-arrow__block">
                      <LeftArrowIcon onClick={() => scrollClickHandler('mapBoxPageH1')} />
                    </div>
                  )}
                </span>
              )}
              <span style={{ display: 'table-cell', color: '#1A1A1A' }}>
                {option && `${isPreviewStrPresent ? '' : props.idx + 1 + '.'}${option.optionName}`}
              </span>
            </div>
            {showNav === true ? (
              <div>
                <div className="optionDetails__title">
                  {' '}
                  {option.address && option.address.address}
                </div>
                <div className="optionDetails__subtitle">
                  {currentDeal?.['Client Name']?.[0].toLowerCase() ===
                  CUSTOM_CLIENT_NAME.toLowerCase()
                    ? option && option.address && getDistance(option.address, 'km', props.latLong)
                    : option &&
                      option.address &&
                      getDistance(option.address, 'miles', props.latLong)}
                </div>
              </div>
            ) : (
              <div className="optionDetails__title"> {option?.address}</div>
            )}
          </div>

          {!pdfDownload && (
            <div className="tabs">
              <nav>
                <ul className="main-nav">
                  <li className="floor">
                    <div onClick={displayFloor} className={floorClick ? 'active' : 'inactive'}>
                      Floor plans
                    </div>
                  </li>
                  <li className="photos">
                    <div onClick={displayPhotos} className={photosClick ? 'active' : 'inactive'}>
                      Photos
                    </div>
                  </li>
                </ul>
              </nav>
            </div>
          )}

          {!pdfDownload && (
            <div style={{ maxWidth: '95%' }}>
              {showPhotos === true ? <ImageSlider option={option} /> : null}
              {showFloorPlans === true
                ? setFloorPlanImage() && <div style={{ marginTop: '2.5rem' }}>{floorImage()}</div>
                : null}
            </div>
          )}
          {pdfDownload && setFloorPlanImage() && (
            <div className="floorImageBlock">{floorImage()}</div>
          )}
        </div>
        <div className="rightHalf">
          <div
            className="detailPanel"
            style={{
              height: showNav === false || isShortlistedSearch == 'true' ? '90%' : '65%',
            }}
          >
            <div className="availBlock">
              <div className="subHeading">Availability</div>
              <div className="textDisplay">Desks: {calcCapacity(option)}</div>
              <div className="textDisplay" style={{ marginLeft: '2.5rem' }}>
                Date: {formatDate(option)}
              </div>
            </div>

            <div className="separator"></div>
            <div className="costPerMonthBlock">
              <div className="subHeading">Cost per term</div>
              <div className="costPerMonth__row">
                {option.ratesToInclude && isRatesToInclude(option, '1') && (
                  <div className="costPerMonth__col">
                    <h6 className="term__heading">1 Month</h6>
                    <div className="monthTerm__value">
                      {monthTerms.rateOneMonth !== '' ? monthTerms.rateOneMonth : null}
                    </div>
                  </div>
                )}
                {option.ratesToInclude && isRatesToInclude(option, '6') && (
                  <div className="costPerMonth__col">
                    <h6 className="term__heading">6 Months</h6>
                    <div className="monthTerm__value">
                      {monthTerms.rateSixMonths !== '' ? monthTerms.rateSixMonths : null}
                    </div>
                  </div>
                )}
                {option.ratesToInclude && isRatesToInclude(option, '12') && (
                  <div className="costPerMonth__col">
                    <h6 className="term__heading">12 Months</h6>
                    <div className="monthTerm__value">
                      {monthTerms.rateTwelveMonths !== '' ? monthTerms.rateTwelveMonths : null}
                    </div>
                  </div>
                )}
                {option.ratesToInclude && isRatesToInclude(option, '24') && (
                  <div className="costPerMonth__col">
                    <h6 className="term__heading">24 Months</h6>
                    <div className="monthTerm__value">
                      {monthTerms.ratetwentyfourmonths !== ''
                        ? monthTerms.ratetwentyfourmonths
                        : null}
                    </div>
                  </div>
                )}
                {option.ratesToInclude && isRatesToInclude(option, rateVariableTerm) && (
                  <div className="costPerMonth__col">
                    <h6 className="term__heading">
                      {option.rateVariableTerm !== '' ? `${rateVariableTerm} Months` : null}
                    </h6>
                    <div className="monthTerm__value">
                      {monthTerms.rateVariable !== '' ? monthTerms.rateVariable : null}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="separator"></div>
            <div className="spaces">
              <div className="subHeading">Office #</div>

              {option?.availableSpaceList?.map((avail) => (
                <div key={avail && avail.areaMeasurement} className="space__desc">
                  Unit {avail && avail.unit} {avail && avail.officeType}, A{' '}
                  {avail && avail.productType} with {avail && avail.capacity} desks
                  {avail && avail.floor > 0 ? ', Floor #' + avail.floor : ''}
                  {avail && avail.area ? ', Area ' + avail.area + ' ' : ''}
                  {avail && avail.area && avail?.areaMeasurement ? avail.areaMeasurement : ''}
                </div>
              ))}
            </div>
            <div className="separator"></div>
            <div className="amenitiesBlock">
              <div className="subHeading">Amenities</div>

              <div className="amenities">
                <div className="grid-container">
                  {option?.amenities &&
                    strToArray(option?.amenities) &&
                    strToArray(option?.amenities)?.map((amenity, index) => (
                      <div key={index} className="amenitiesDisplay">
                        <span>-</span>
                        <div> {amenity}</div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
            <div className="separator"></div>
            <div className="notes">
              <div className="subHeading">Notes</div>
              <div className="notes__display">
                {(option.queryData || (data && data?.commonQuestions) || commonQuery) && (
                  <span>
                    <span>
                      <b>Question(s)</b> <br />
                    </span>
                    <span>
                      {option?.queryData?.split('\n').map((text, i) => {
                        if (text) {
                          return (
                            <span style={{ textTransform: 'capitalize' }} key={i}>
                              <span dangerouslySetInnerHTML={{ __html: text }} />
                            </span>
                          );
                        }
                      })}

                      {/* //common questions display */}
                      {data?.commonQuestions?.split('/n').map((q, i) => {
                        if (q) {
                          return (
                            <span key={i}>
                              <span dangerouslySetInnerHTML={{ __html: q }} />
                            </span>
                          );
                        }
                      })}

                      {commonQuery?.split('\n').map((query, i) => {
                        if (query) {
                          return (
                            <span key={i}>
                              <span dangerouslySetInnerHTML={{ __html: query }} />
                            </span>
                          );
                        }
                      })}
                    </span>
                  </span>
                )}
                {option?.queryResponse && (
                  <div>
                    <span>
                      <br />
                      <b>Response(s) </b> <br />
                    </span>
                    {option?.queryResponse?.split('\n').map((text, i) => {
                      if (text) {
                        return (
                          <span key={i}>
                            <span dangerouslySetInnerHTML={{ __html: text }} />
                            <br />
                          </span>
                        );
                      }
                    })}
                    <br />
                  </div>
                )}

                {option?.notes?.split('\n').map((text, i) => {
                  if (text) {
                    return (
                      <span key={i}>
                        <span dangerouslySetInnerHTML={{ __html: text }} />
                        <br />
                      </span>
                    );
                  }

                  return (
                    <span key={i}>
                      <br />
                    </span>
                  );
                })}
              </div>
            </div>
            {isPdfContent && (
              <>
                <div className="separator"></div>
                <div className="tour">
                  <div className="subHeading">Tour Info</div>
                  <div className="tour__details">
                    {!option.tourScheduledDate && option.tourRequestedDate?.length && (
                      <div className="tour__container">
                        <div className="tour__requestedDate">
                          <div className="tourStatus">
                            Tour Requested <img src={tourRequest} alt="Tour Schedule" />
                          </div>
                          <div>
                            <div className="tour__requestedDate">
                              {option.tourRequestedDate.map((requestedDate, index) => (
                                <span key={index}>{changeRequestedDate(requestedDate)}</span>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {option.tourScheduledDate && (
                      <div className="tour__container">
                        <div>
                          <div>
                            {option.tourCompleted ? (
                              <div className="tourStatus">
                                Tour Completed <img src={tourComplete} alt="Tour Schedule" />
                              </div>
                            ) : (
                              <div className="tourStatus">
                                Tour Scheduled <img src={tourSchedule} alt="Tour Schedule" />
                              </div>
                            )}
                            {tourScheduleSlot}
                          </div>
                          <div>
                            {option.contactName && (
                              <div>Provider Contact Name: {option.contactName}</div>
                            )}
                            {option.contactNumber && (
                              <div>Provider Contact Number: {option.contactNumber}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    {option.arrivalDetails && (
                      <div>
                        Arrival Details:
                        <div dangerouslySetInnerHTML={createMarkup(option.arrivalDetails)} />
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
          {!pdfDownload &&
            showNav === true &&
            isShortlistedSearch !== 'preview' &&
            isShortlistedSearch !== 'true' && (
              <div className="requestFor">
                <div
                  className="notes__display"
                  style={{
                    paddingLeft: '0px',
                    paddingTop: '18px',
                    width: '100%',
                  }}
                >
                  <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                  >
                    <div>
                      <QueryModal
                        handleClose={handleClose}
                        requestType={requestType}
                        option={option}
                        simplifiedFunction={simplifiedFunction}
                      />
                    </div>
                  </Modal>

                  <Backdrop
                    className={classes.backdrop}
                    open={openSuccess}
                    onClick={handleSuccessClose}
                  >
                    <SuccessModal message={message} requestType={requestType} />
                  </Backdrop>
                  {isShortlistedSearch !== 'preview' && isShortlistedSearch !== 'true' && (
                    <button
                      type="button"
                      className="button primary requestBtn"
                      onClick={() => handleOpen('QUERY')}
                    >
                      Request More Info
                    </button>
                  )}
                  {isShortlistedSearch !== 'preview' && isShortlistedSearch !== 'true' && (
                    <button
                      type="button"
                      title="Click here to shortlist"
                      className="button primary requestBtn"
                    >
                      {/* Click here to shortlist */}
                      <span onClick={toggleIcon}>
                        <HeartIcon color={isSelected ? '#FF543E' : '#778F9C'} />
                        <span style={{ paddingLeft: '8px' }}>Shortlist</span>
                      </span>
                    </button>
                  )}
                  {currentProvider?.length > 0 && currentProvider?.[0]?.pdfPath && (
                    <button
                      type="button"
                      title="Click here to view provider profile"
                      className="button profileBtn"
                      onClick={() => setShowProfileModal(true)}
                      disabled={currentProvider?.length < 1}
                    >
                      {/* Click here to shortlist */}
                      Provider Profile
                    </button>
                  )}
                </div>
              </div>
            )}
        </div>
        {showProfileModal && (
          <ProviderProfile
            currentProvider={currentProvider?.[0]}
            hideModal={() => setShowProfileModal(false)}
          />
        )}
      </div>
      {/* {!pdfDownload && <ImageDisplay option={option} />} */}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    latLong: state.comRed.latLong,
    surveyData: state.optRed.data.survey,
    ccemails: state.comRed.displayCCMails,
    shortlistedProviderName: state.comRed.displayShortlistedProvider,
    shortlistedProviderEmails: state.comRed.displayShortlistedProviderContact,
    flexpertEmail: state.comRed.displayMails,
    optData: state.optRed.data,
    commonQuery: state.comRed.displayCommonQuery,
    pdfDownload: state.comRed.pdfDownload,
    currentDeal: state.comRed.currentDeal,
    majorProviders: state.optRed.majorProviders,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setCommonQuery: (commonQuery) => dispatch({ type: 'SET_COMMON_QUERY', commonQuery }),
    addToShortlistedOptions: (option) => dispatch({ type: 'SELECT', option }),
    removeFromShortlistedOptions: (id) => dispatch({ type: 'DESELECT', id }),
    updateCapacity: (data) => dispatch({ type: 'UPDATE_CAPACITY', data }),
    setIsShortlisted: (id, val) => dispatch({ type: 'SET_ISSHORTLISTED', id, val }),
  };
};

export { getDistance };

export default connect(mapStateToProps, mapDispatchToProps)(OptionDetail);
